import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = ({ title, excludedPaths = [], group }) => {
  const location = useLocation();
  const paths = location.pathname.split("/").filter((path) => path !== "");

  return (
    <div className="mx-auto mb-4">
      <nav className="flex flex-col md:flex-row justify-between">
        <p className="text-md md:text-xl lg:text-2xl">{title}</p>
        <div className="flex p-0 items-center">
          <span className="mr-3">You're here : </span>
          <ol className="list-none p-0 flex">
            {group === "Superadmin" && (
              <span className="text-xs md:text-base">
                <Link
                  to="/administrator/dashboard/admin"
                  className={`${
                    excludedPaths[0] === "dashboardadmin"
                      ? "text-gray-500 dark:text-white"
                      : "text-blue-500"
                  } hover:underline text-xs md:text-base`}
                >
                  Admin Panel{" "}
                </Link>
                /{" "}
              </span>
            )}

            {paths.map((path, index) => {
              const url = `/${paths.slice(0, index + 1).join("/")}`;
              const isLast = index === paths.length - 1;

              // Tambahkan kondisi untuk mengabaikan path yang ada dalam excludedPaths
              if (excludedPaths.includes(path)) {
                return null;
              }

              return (
                <li
                  key={index}
                  className="flex items-center text-xs md:text-base"
                >
                  {!isLast ? (
                    <Link
                      to={url}
                      className="text-blue-500 hover:underline text-xs md:text-base"
                    >
                      {path.charAt(0).toUpperCase() + path.slice(1)}
                    </Link>
                  ) : (
                    <span className="text-gray-500 dark:text-white text-xs md:text-base">
                      {path.charAt(0).toUpperCase() + path.slice(1)}
                    </span>
                  )}
                  {!isLast && (
                    <span className="text-gray-500 dark:text-white mx-1 text-xs md:text-base">
                      /
                    </span>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </nav>
    </div>
  );
};

export default Breadcrumb;
